<template>
  <!-- edit profile dialog -->
  <v-dialog
    v-model="isBioDialogOpen"
    max-width="650px"
    @click:outside="$emit('update:is-bio-dialog-open',false)"
  >
    <v-card class="class-edit-info pa-sm-10 pa-3">
      <v-card-title class="justify-center text-h5">
        Klas bewerken
      </v-card-title>
      <v-card-text class="text-center mt-n2">
        Vergeet niet je wijzigingen op te slaan
      </v-card-text>

      <v-card-text class="mt-5">
        <v-form class="multi-col-validation">
          <v-row>
            <!-- Klasnaam -->
            <v-col
              cols="12"
              sm="12"
            >
              <v-text-field
                v-model="classDataLocal.name"
                outlined
                dense
                label="Naam"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              class="d-flex justify-center mt-3"
            >
              <v-btn
                color="primary"
                class="me-3"
                type="submit"
                @click.prevent="onSubmit"
              >
                Opslaan
              </v-btn>

              <v-btn
                outlined
                color="secondary"
                @click.prevent="$emit('update:is-bio-dialog-open',false)"
              >
                Sluiten
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from '@axios'
import { ref, watch } from '@vue/composition-api'

export default {
  props: {
    isBioDialogOpen: {
      type: Boolean,
      required: true,
    },
    classData: {
      type: Object,
      required: true,
    },
    loginMethods: {
      type: Array,
      required: true,
    },
    classes: {
      type: Array,
      required: true,
    },
  },

  setup(props, { emit }) {
    const isBillingAddress = ref(true)

    const classDataLocal = ref({})
    classDataLocal.value = JSON.parse(JSON.stringify(props.classData))
    classDataLocal.value.selectedClass = classDataLocal.value.class ? classDataLocal.value.class.id : 'none'

    const statusOptions = [
      { title: 'Pending', value: 'pending' },
      { title: 'Active', value: 'active' },
      { title: 'Inactive', value: 'inactive' },
    ]
    const languageOptions = ['English', 'Spanish', 'Portuguese', 'Russian', 'French', 'German']

    // on form submit
    const onSubmit = async () => {
      try {
        console.log(classDataLocal.value)
        const school = JSON.parse(localStorage.getItem('school'))

        // Update account
        const updated = await axios.put(`/school/${school.id}/class/${props.classData.id}`, classDataLocal.value)
        console.log(updated.data)
        if (!updated.data.success) throw new Error('Could not update account')

      // Refresh class data
      } catch (error) {
        // toast('error', 'Foutief wachtwoord', 'Probeer het opnieuw')
        console.log(error)
      } finally {
        emit('refetch-data')
        emit('update:is-bio-dialog-open', false)
      }
    }

    watch(
      () => props.isBioDialogOpen,
      () => {
        classDataLocal.value = JSON.parse(JSON.stringify(props.classData))
        classDataLocal.value.selectedClass = classDataLocal.value.class ? classDataLocal.value.class.id : 'none'
      },
    )

    return {
      isBillingAddress,
      statusOptions,
      languageOptions,
      classDataLocal,
      onSubmit,
    }
  },
}
</script>
